import React from 'react';

import { ActionButton, ActionsContainer } from './actions.styled';
import { useSearchAndShuffleContext } from './context';
import { useActions } from './use-actions';

type ActionsProps = {
  index: number;
};

export const Actions: React.FC<ActionsProps> = ({ index }) => {
  const allActions = useActions();
  const { decks, executingAction } = useSearchAndShuffleContext();
  const deck = decks[index];

  if (!deck || !deck.cards.length) {
    return null;
  }

  const actions = allActions[deck.cards[0].type];

  return (
    <ActionsContainer $items={actions?.buttons?.length || 0}>
      {actions?.buttons?.map((button, i) => (
        <ActionButton
          key={i}
          variant={button.variant || 'onColorStrong'}
          icon={button.icon}
          aria-label={button.a11y}
          onClick={() => button.action(index)}
          disabled={executingAction}
          $color={button.color}
          $size={button.size || 'medium'}
        />
      ))}
    </ActionsContainer>
  );
};
